import React from "react";

import { PromoCardBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonPrimary } from "../../Clickables";
import { H } from "../../Headings";
import { getThemeClass } from "../../ThemedModule";
import { VARIANT } from "../index";

import styles from "./TwoUpCards.module.scss";

interface TwoUpCardsProps {
    cards: PromoCardBlock[];
}

export const TwoUpCards = ({ cards }: TwoUpCardsProps) => {
    return (
        <div className={styles.twoUpContainer}>
            {cards.map((card, index) => {
                const variant = card.variant || VARIANT.IMAGE_FILL;
                const isImageFill = variant === VARIANT.IMAGE_FILL;
                const isImageBlock = variant === VARIANT.IMAGE_BLOCK;

                return (
                    <div
                        key={index}
                        className={concatClassNames([
                            styles.twoUpCard,
                            isImageFill ? styles.imageFill : styles.imageBlock,
                            isImageBlock ? getThemeClass(card.theme) : "",
                        ])}
                    >
                        {card.image && (
                            <div className={styles.imageWrapper}>
                                <ImageChooserBlock
                                    value={card.image}
                                    attrs={{}}
                                />
                            </div>
                        )}

                        <div className={styles.contentWrapper}>
                            <H className={styles.headline}>{card.headline}</H>

                            {card.body && (
                                <p className={styles.body}>{card.body}</p>
                            )}

                            {card.link && (
                                <div className={styles.ctaWrapper}>
                                    <ButtonPrimary simpleLink={card.link} />
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
